/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Marin POST /courses/:courseId/integration/:integrationId/unlink — starts async LMS unpairing.
 * Responds with { taskId, href }.
 *
 * @file UnlinkCourseService.js
 * @author Satyaki Bose
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  COURSE_UNLINK_REQUESTED,
  COURSE_UNLINK_FETCHED,
  COURSE_UNLINK_FAILED
} from '../../../common/constants';

export default class UnlinkCourseService extends BaseService {
  constructor() {
    super(COURSE_UNLINK_REQUESTED, 'courseUnlinkStatus');
  }

  handleEvent(eventName, { courseId, integrationId }) {
    return this.getClient('marin').post(`/courses/${courseId}/integration/${integrationId}/unlink`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse({ data }) {
    Framework.getEventManager().publish(COURSE_UNLINK_FETCHED, data);
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(COURSE_UNLINK_FAILED, error);
  }
}
